/**
 * Created by Ning Jiang on 10/1/2018.
 */
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";

export class TombstoneGameMode extends GameMode{
    public static readonly SUPER_FREESPIN:string = "SUPER_FREESPIN";
}